import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Joins class names and lets a later one win over an earlier one.
 *
 * Needed because every primitive here takes a `className` for the caller to
 * override with. Plain template concatenation puts both classes in the
 * attribute and leaves the winner to CSS source order, so a caller passing
 * `px-2` to a component whose base is `px-3.5` got whichever Tailwind happened
 * to emit last. twMerge resolves the conflict by intent instead.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
